import { render, staticRenderFns } from "./DiagnosisResult.vue?vue&type=template&id=8993eb02&scoped=true&"
import script from "./DiagnosisResult.vue?vue&type=script&lang=js&"
export * from "./DiagnosisResult.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisResult.vue?vue&type=style&index=0&id=8993eb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8993eb02",
  null
  
)

export default component.exports